export default "__VITE_ASSET__AyCj6xCW__"